// extracted by mini-css-extract-plugin
export var errorIcon = "_ke-1";
export var nameLogo = "_ke-0";